// extracted by mini-css-extract-plugin
module.exports = {"OrderRejected":"style_OrderRejected__hOndH","Circle":"style_Circle__AouBy","Title":"style_Title__dFxbD","SubTitle":"style_SubTitle__Cuskn"};